import {
    apiRequest,
    PNSdetailPNS,
    ApproveDokumen
} from "../../../../../services/adapters/kepegawaian/DokumenPNSService"

class DetailRepository {


    fetchDetail = async (query) => {
        return await apiRequest("get", PNSdetailPNS, {
            params: query
        }, true)
    }
    approveDokumen = async (query) => {
        return await apiRequest(
          "post",
          ApproveDokumen,
          {
            body: query,
          },
          true
        );
      };
}

export default DetailRepository